/**
 * Stripe Payment Links centralisés.
 * Quand un lien est `null`, le service reste en "devis manuel" (mailto / formulaire).
 * Quand un lien est une URL, un bouton "💳 Payer en ligne" s'affiche en plus.
 *
 * Pour ajouter un nouveau lien : crée-le sur https://dashboard.stripe.com/payment-links
 * puis colle l'URL https://buy.stripe.com/... ci-dessous.
 *
 * Clés alignées sur les `slug` ou identifiants des services.
 */

// ⚠️ Les clés DOIVENT correspondre exactement aux `slug` définis dans
// src/pages/Tarifs.jsx (sinon le bouton "Payer en ligne" ne s'affiche pas).
export const STRIPE_LINKS = {
  // ━━━ ACTIFS ━━━
  'express':          'https://buy.stripe.com/14A3cw7QQ6vR8IGd0r8IU0N',  // 49€ — Pré-diagnostic Express (5 pages, 24h)
  'tableau-bord':     'https://buy.stripe.com/14AfZic767zV8IG8Kb8IU0H',  // 150€/mois
  'scoring':          'https://buy.stripe.com/4gM6oIb32g6rgb8gcD8IU0D',  // 200€
  'analyse':          'https://buy.stripe.com/aFafZic765rNbUS1hJ8IU0E',  // 300€
  'audit-tresorerie': 'https://buy.stripe.com/14A14o9YY07t9MK7G78IU0F',  // 350€
  'previsionnel':     'https://buy.stripe.com/3cI8wQefe8DZf749Of8IU0M',  // 500€
  'etude-marche':     'https://buy.stripe.com/cNi28s7QQ7zVgb88Kb8IU0I',  // 600€
  'business-plan':    'https://buy.stripe.com/fZu6oIgnm4nJcYW0dF8IU0J',  // 700€
  'valorisation':     'https://buy.stripe.com/7sY4gA1ssf2n6AyaSj8IU0G',  // 900€
  'cession':          'https://buy.stripe.com/7sY8wQ9YY2fB7EC5xZ8IU0K',  // 1 200€
  'pack-complet':     'https://buy.stripe.com/9B6bJ2fjig6r8IG1hJ8IU0L',  // 1 500€

  // ✅ Catalogue 10/10 services payables en ligne — Diagnostic = gratuit (pas de Stripe)
};

/**
 * Helper : retourne l'URL Stripe pour un service, ou null si pas encore configuré.
 */
export function getStripeLink(serviceKey) {
  return STRIPE_LINKS[serviceKey] || null;
}

/**
 * Helper : True si on a un lien Stripe actif pour ce service.
 */
export function hasStripeLink(serviceKey) {
  return !!STRIPE_LINKS[serviceKey];
}
